import { isBmsSmsProvider } from 'src/utils/bms-sms-encoding';

import { PasswordField } from 'src/pages/channel/shared';

import { Field } from 'src/components/hook-form';

type SmsFieldProps = {
  t: (key: string) => string;
  provider?: string | null;
};

export const SmsField = ({ t, provider }: SmsFieldProps) => {
  const isBms = isBmsSmsProvider(provider);

  return (
    <>
      <Field.Text
        name="accountSid"
        label={isBms ? t('SMS_BMS_FIELD_USER') : t('ACCOUNT_ID')}
        InputLabelProps={{ shrink: true }}
        placeholder={isBms ? t('SMS_BMS_FIELD_USER_PLACEHOLDER') : t('ENTER_ACCOUNT_ID')}
      />
      <PasswordField
        name="authToken"
        label={isBms ? t('SMS_BMS_FIELD_PASSWORD') : t('AUTH_TOKEN')}
        placeholder={isBms ? t('SMS_BMS_FIELD_PASSWORD_PLACEHOLDER') : t('ENTER_AUTH_TOKEN')}
      />
      <Field.Text
        name="srcNumber"
        label={isBms ? t('SMS_BMS_FIELD_SENDER') : t('SOURCE_NUMBER')}
        InputLabelProps={{ shrink: true }}
        placeholder={isBms ? t('SMS_BMS_FIELD_SENDER_PLACEHOLDER') : t('ENTER_SOURCE_NUMBER')}
      />
    </>
  );
};
